// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"753abfe2","239":"60216727","344":"1be42899","451":"60a6b6ed","455":"cc2fc374","809":"71f8199e","977":"ffd0d9da"}[chunkId] + ".chunk.js";
};